import React, { useState } from "react";
import { IStory } from "pages/People/people.types";
import { ChaptersEl, Wrapper } from "./wallHeader.styles";
import { Button } from "@atoms";
import Editor from "../editor/Editor";
import { ChapterEditorDataProvider } from "contexts/ChapterEditorContext";
import { useTranslation } from "react-i18next";
import { useWallDataContext } from "contexts/WallContext";
import { useIsMobile } from "hooks";

function WallHeader({story}: {story: IStory}) {
  const { t } = useTranslation();
  const { isCreator } = useWallDataContext();
  const isMobile = useIsMobile();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Wrapper>
      <ChaptersEl>{t('wall.chapters')}</ChaptersEl>
      {isCreator && (
        <Button variant={"outlined"} onClick={() => setIsOpen(true)}>+</Button>
      )}
      {isOpen && (
        <ChapterEditorDataProvider storyId={story.uuid}>
          <Editor isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </ChapterEditorDataProvider>
      )}
    </Wrapper>
  );
}

export default WallHeader;
